import styled, { css } from "styled-components";

import { BoxSizingStyle } from "../../BoxSizingStyle";
import { FontStyle } from "../../FontStyle";

export const StyledSteps = styled.div`
  ${FontStyle}
  ${BoxSizingStyle}

  display: flex;
  justify-content: center;
`;

export const StyledStep = styled.div<{ $isActiveStep: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: var(--color-theme-400);
  border-radius: 50%;
  margin: 0 5px;

  ${(props) =>
    props.$isActiveStep &&
    css`
      background-color: var(--color-primary);
    `}
`;

StyledSteps.displayName = "StyledSteps";
StyledStep.displayName = "StyledStep";
